// No changes needed for hostServer/applicationAlias localStorage keys in this file.

// Function to load state from localStorage
export const loadState = () => {
  try {
    const serializedState = localStorage.getItem('reduxState');
    if (serializedState === null) {
      return undefined; // No state in localStorage, let reducers initialize
    }
    const persistedState = JSON.parse(serializedState);
    
    // Return the persisted state, which will be used as preloadedState
    return persistedState;

  } catch (err) {
    console.error("Could not load state", err);
    return undefined;
  }
};

// Function to save state to localStorage
export const saveState = (state) => {
  try {
    // We want to persist the dynamic data (emails, messages) but also keep
    // the rest of the channel state so we don't lose config on reload.
    const stateToPersist = {
      channel: {
        ...state.channel,
        emails: state.channel.emails,
        messages: state.channel.messages,
      },
    };
    const serializedState = JSON.stringify(stateToPersist);
    localStorage.setItem('reduxState', serializedState);
  } catch (err) {
    console.error("Could not save state", err);
  }
};
